import React, { useState, useEffect } from 'react';
import { FiDownload } from 'react-icons/fi'; // npm install react-icons
import '../../styles//crud.css';
import '../../styles//botones_dflt.css';
import Spinner from "../spinner";
import * as apiPolizas from '../../services/apiPolizas.js';
import * as apiTiposDocumentos from '../../services/apiTiposDocumentos.js';
import { convertFileToBase64, descargarDocumentoPoliza } from '../../functions/fileFunctions.js';
import * as alerts from '../../functions/alerts.js';


const DocPolizas = ({ polizaId }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // Estado para almacenar filas
  const [formData, setFormData] = useState({ id: '',poliza: '',nombre: '', tipo: '', extension: '', contenido: ''}); // Estado del formulario
  const [isFormModalOpen, setIsFormModalOpen] = useState(false); // Control del modal de ingreso/edición
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Control del modal de eliminación
  const [deleteIndex, setDeleteIndex] = useState(null); // Índice de la fila a eliminar
  const [isEditing, setIsEditing] = useState(false); // Estado para editar
  const [editIndex, setEditIndex] = useState(null); // Índice de la fila a editar
  const [tipoDocOptions, setTipoDocOptions] = useState([]);

  // Cargar datos desde la API al montar el componente
    const fetchData = async (polizaID) => {
        try{
          const json = await apiPolizas.listarDocumentos(polizaID);
          if (json.documentos_list){
            const formattedData = json.documentos_list.map((item) => ({
                id: item.id,
                poliza: item.poliza,
                nombre: item.nombre,
                tipo: item.tipo,
                extension: item.extension,
                ruta: item.ruta,
            }));
            setData(formattedData);
          }else
          {
           setData({}); 
          }
            const jsonTipoDoc = await apiTiposDocumentos.cargarTiposDocumentos(1);
            if(jsonTipoDoc){
            const tipoDoc = jsonTipoDoc.tiposDocs.map((item) => ({
                id: item.id,
                tipo: item.tipo
            }));
            setTipoDocOptions(tipoDoc);
            }
            setLoading(false);
        } catch (error) {
          console.error('Error al cargar los datos:', error);
      }
    };

  const storedUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
      fetchData(polizaId);
    }, [polizaId]);

  // Abrir el modal de formulario para agregar o editar
  const openFormModal = async (index = null) => {
    if (index !== null) {
        setIsEditing(true);
        setEditIndex(data[index].id);
        const formattedData = ({
            tipo: data[index].tipo,
          });
        setFormData(formattedData);
    } else {
      setFormData({ tipo: '-1'}); 
      setIsEditing(false);
    }
    setIsFormModalOpen(true);
  };

  // Cerrar el modal de formulario
  const closeFormModal = () => {
    if (polizaId){
      fetchData(polizaId);
    }
    setIsFormModalOpen(false);
  };

  // Guardar datos (Agregar o Editar)
  async function handleFormSubmit(e) {
    e.preventDefault();
    if (isEditing) {
      try {
//gestion de siniesto
        const response = await apiPolizas.actualizarDocumento(formData, storedUser, editIndex);
        if (response.ok) {
          alerts.handleSuccess('Éxito!','Cambios guardados correctamente')
        } else {
          console.error('Error al guardar cambios:', response.statusText);
        }
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
    } else {
      const response = await apiPolizas.agregarDocumento(formData, polizaId, storedUser);
      if (response.ok) {
        const data = await response.json();
        console.log(data)
        alerts.handleSuccess('Éxito!','Documento cargado correctamente')
        setIsFormModalOpen(false);
      } else {
        console.error('Error al agregar nuevo documento:', response.statusText);
      }
    }
    closeFormModal();
  }

  const openDeleteModal = (index) => {
    setDeleteIndex(index);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    const response = await apiPolizas.eliminarDocumento(data[deleteIndex].id,storedUser);
    if (response.ok) {
      alerts.handleSuccess('Éxito!','Documento eliminado correctamente')
    } else {
      console.error('Error al eliminar el documento:', response.statusText);
    }
    if (polizaId) {
      fetchData(polizaId);
    }
    closeDeleteModal();
  };

  const handleChangeDoc = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const nombre_ = file.name;
    const extension_ = file.name.split('.').pop();
    const contenido_ = await convertFileToBase64(file);
    setFormData({ ...formData, nombre: nombre_, extension:extension_, contenido:contenido_});
  };

  const handleChangeTipoDoc = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

  };
  
  const obtenerNombreTipo = (id) => {
    const tipo = tipoDocOptions.find(item => item.id === id);
    return tipo ? tipo.tipo : '—';
  };

  return (
    <div className="crud-table">
    {!loading && <button className='button_new' onClick={() => openFormModal()}>Añadir Documento</button>}
      {/* Tabla */}
      {loading ? <Spinner /> :
      <table>
        <thead>
          <tr>
            <th>Tipo</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item.id}>
                <td>{obtenerNombreTipo(item.tipo)}</td>
                <td>                    
                    <button onClick={() => descargarDocumentoPoliza(item.id)}style={{ textDecoration: 'none', color: 'black', background: 'none' }}>
                        <FiDownload size={30}/>
                    </button>
                </td>
                <td>
                  <button className="editar" onClick={() => openFormModal(index)}>Editar</button>
                  <button className="eliminar" onClick={() => openDeleteModal(index)}>Eliminar</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No hay datos</td>
            </tr>
          )}
        </tbody>
      </table>}

      {/* Modal de Formulario */}
      {isFormModalOpen && (
        <div className="modal">
          <div className="modal-content modal-content-wide">
            <h2>{isEditing ? 'Editar Documento' : 'Añadir Documento'}</h2>
            <table>
                <tbody>
                    <tr>
                        <td className='modal-region'>
                            <h3>Información General</h3>
                            <form className='form_crud'>
                                <select id="options"
                                    type="text"
                                    name="tipo"
                                    placeholder="Tipo Documento"
                                    value={formData.tipo}
                                    onChange={(e) => handleChangeTipoDoc(e)}
                                    required
                                    disabled={isEditing}
                                >   <option key='-1' value='-1'>
                                      --Seleccione un tipo--
                                    </option>
                                    {tipoDocOptions.map((option) => (
                                    <option key={option.id} value={option.id} disabled={option.id === "0"}>
                                      {option.tipo}
                                    </option>
                                    ))}
                                  </select>
                                <input
                                  id="archivo"
                                  type="file"
                                  name="archivo"
                                  placeholder="Elija el archivo a cargar"
                                  onChange={(e) => handleChangeDoc(e)}
                                  required
                                />
                            </form>
                        </td> 
                    </tr>
                </tbody>
            </table>
            <button type="submit" className='guardar' onClick={handleFormSubmit}>{isEditing ? 'Actualizar' : 'Añadir'}</button>
            <button type="button" className='cancelar' onClick={closeFormModal}>Cancelar</button>
          </div>
        </div>
      )}

      {/* Modal de Confirmación de Eliminación */}
      {isDeleteModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Confirmar Eliminación</h2>
            <p>¿Estás seguro de que deseas eliminar este registro?</p>
            <button onClick={confirmDelete}>Sí, eliminar</button>
            <button onClick={closeDeleteModal}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocPolizas;